import React from 'react';
import { useAuth } from '@/context/AuthContext';

const PortalProfile = () => {
  const { user } = useAuth();
  return (
    <div className="max-w-[600px]">
      <h1 className="font-heading text-2xl font-bold text-slate-900 mb-4">My Profile</h1>
      <div className="bg-white border border-slate-200 rounded-lg p-6">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-14 h-14 rounded-full grid place-items-center bg-[#eaf3fb] text-[#1e73be] font-bold text-xl">
            {(user.name || user.email).charAt(0).toUpperCase()}
          </div>
          <div>
            <p className="font-heading font-bold text-lg text-slate-900">{user.name}</p>
            <p className="text-sm text-slate-500">{user.email}</p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-slate-500 text-xs uppercase tracking-wide mb-1">Role</p>
            <p className="font-semibold text-slate-800 capitalize">{user.role}</p>
          </div>
          <div>
            <p className="text-slate-500 text-xs uppercase tracking-wide mb-1">Status</p>
            <p className="font-semibold text-slate-800 capitalize">{user.status}</p>
          </div>
          <div className="col-span-2">
            <p className="text-slate-500 text-xs uppercase tracking-wide mb-1">Member since</p>
            <p className="font-semibold text-slate-800">{new Date(user.created_at).toLocaleDateString()}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortalProfile;
